import { motion } from 'framer-motion';
import { Link } from '@tanstack/react-router';
import { Button } from '@kamalkari/ui';
import { KolamMandala, KolamDivider } from './KolamPattern';

export function ArtistStory() {
  return (
    <section className="bg-warm-50 py-20 relative overflow-hidden">
      {/* Decorative Kolam patterns */}
      <KolamMandala className="absolute top-10 right-10 w-48 h-48 text-warm-200 opacity-30" />
      <KolamMandala className="absolute bottom-10 left-10 w-32 h-32 text-warm-200 opacity-20" />

      <div className="container-page relative">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image side - Gallery style */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            {/* Main artist image in frame */}
            <div className="relative">
              <div className="bg-white p-4 shadow-xl">
                <div className="aspect-[3/4] bg-warm-100 overflow-hidden">
                  <img
                    src="/products/notebooks-frames.jpg"
                    alt="Aarti - The Artist"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Museum-style label */}
              <div className="absolute -bottom-4 left-8 right-8 bg-white shadow-lg p-4">
                <p className="text-xs uppercase tracking-wider text-warm-500 mb-1">The Artist</p>
                <p className="font-serif text-warm-900 text-lg">Aarti</p>
                <p className="text-sm text-warm-600">Kolam Artist & Founder</p>
              </div>
            </div>

            {/* Floating detail image */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="absolute -right-4 top-1/4 w-32 bg-white p-2 shadow-lg hidden md:block"
            >
              <img
                src="/products/mugs.jpg"
                alt="Kolam detail"
                className="w-full aspect-square object-cover"
              />
            </motion.div>
          </motion.div>

          {/* Text side */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <p className="text-xs font-medium tracking-[0.3em] uppercase text-ochre mb-4">
              Artist Statement
            </p>
            <h2 className="text-4xl sm:text-5xl font-serif text-warm-900 mb-6">
              The Art of Kolam
            </h2>

            <KolamDivider className="w-48 h-6 text-warm-400 mb-8" />

            <div className="space-y-5 text-warm-600 mb-8">
              <p className="text-lg leading-relaxed">
                Kolam is more than art—it's a sacred morning ritual passed down through
                generations of South Indian women. Each dot and curve carries meaning,
                blessing thresholds with geometric prayers.
              </p>
              {/* <p className="leading-relaxed">
                I'm Aarti, and my journey began on my grandmother's doorstep in Tamil Nadu,
                watching her fingers trace ephemeral patterns in rice flour at dawn. Those
                fleeting moments of beauty sparked a lifelong devotion to preserving this
                ancient art form.
              </p> */}
              <p className="leading-relaxed">
                Today, I transform these sacred geometries into lasting pieces—from ceramic
                mugs that hold your morning chai to wall frames that bring blessings into
                your home. Each design is hand-drawn with intention, digitised with care,
                and crafted in small batches.
              </p>
            </div>

            <blockquote className="border-l-2 border-ochre pl-6 mb-8">
              <p className="font-serif text-xl text-warm-800 italic">
                "Every kolam is a meditation, every product a blessing.
                Let's gift artfully—together."
              </p>
              <footer className="mt-3 text-sm text-warm-500">— Aarti</footer>
            </blockquote>

            <Button asChild variant="outline" size="lg" className="border-warm-400 text-warm-700 hover:bg-warm-100">
              <Link to="/about">Read Full Story</Link>
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
